import * as React from 'react';

import { translate } from '~l10n/client';

export function FreePriceComponent() {
  return (
    <>
      <div className={'flex flex-row '}>
        <span
          className={'font-display text-lg font-700 text-blue-900 leading-12'}
        >
          {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            currencyDisplay: 'narrowSymbol',
          }).format(0)}
        </span>
      </div>
      <div className={'text-base font-sans text-blue-900 leading-8'}>
        {translate('Forever')}
      </div>
      <div className={'text-sm font-sans text-blue-600 leading-8 pb-4'}></div>
    </>
  );
}
